import { Options } from '@splidejs/react-splide';

export const brokerLogoCarouselItems = [
  { src: '/images/brokers/iifl-capital.svg', alt: 'iifl-capital logo' },
  { src: '/images/brokers/jainam-broking.svg', alt: 'jainam-broking logo' },
  { src: '/images/brokers/kotak-neo.svg', alt: 'kotak-neo logo' },
  { src: '/images/brokers/philip-capital.svg', alt: 'philip-capital logo' },
  { src: '/images/brokers/finvasia.svg', alt: 'finvasia logo' },
  { src: '/images/brokers/bigul.svg', alt: 'bigul logo' },
  { src: '/images/brokers/samco.svg', alt: 'samco logo' },
  { src: '/images/brokers/rupeezyy.svg', alt: 'rupeezy logo' },
  { src: '/images/brokers/profitmart.svg', alt: 'profitmart logo' },
  { src: '/images/brokers/fyers.svg', alt: 'fyers logo' },
  { src: '/images/brokers/mstock.svg', alt: 'mstock logo' },
  { src: '/images/brokers/sharekhan.svg', alt: 'sharekhan logo' },
  { src: '/images/brokers/smc-global.svg', alt: 'smc-global logo' },
  { src: '/images/brokers/sky-broking.svg', alt: 'sky-broking logo' },
  { src: '/images/brokers/trade-smart.svg', alt: 'trade-smart logo' },
  { src: '/images/brokers/zebull.svg', alt: 'zebu logo' },
  { src: '/images/brokers/upstox.svg', alt: 'upstox logo' },
  { src: '/images/brokers/stocko.svg', alt: 'Stocko logo' },
  { src: '/images/brokers/nuvama.svg', alt: 'nuvama logo' },
  { src: '/images/brokers/kbs.svg', alt: 'kbs logo' },
  { src: '/images/brokers/goodwill.svg', alt: 'goodwill logo' },
  { src: '/images/brokers/flattradee.svg', alt: 'flattrade logo' },
  { src: '/images/brokers/fivepaisa.svg', alt: 'fivepaisa logo' },
  { src: '/images/brokers/bonanza.svg', alt: 'bonanza logo' },
  { src: '/images/brokers/dhan.svg', alt: 'dhan logo' },
  { src: '/images/brokers/axis-direct.svg', alt: 'axis-direct logo' },
  { src: '/images/brokers/arihant-plus.svg', alt: 'arihant-plus logo' },
  { src: '/images/brokers/ac-agarwal.svg', alt: 'ac-agarwal logo' },
  { src: '/images/brokers/groww.svg', alt: 'groww logo' },
  { src: '/images/brokers/indira-securities.svg', alt: 'indra-securities logo' },
];

export const options: Options = {
  type: 'loop', // Loop back to the beginning when reaching the end
  autoScroll: {
    pauseOnHover: false, // Do not pause scrolling when hovering over the carousel
    pauseOnFocus: false, // Do not pause scrolling when the carousel is focused
    rewind: true, // Rewind to start when the end is reached
    speed: 1, // Scrolling speed
  },
  arrows: false, // Hide navigation arrows
  pagination: false, // Hide pagination dots
  // fixedWidth: 200, // or any consistent size
  autoWidth: true,
  speed: 3000, // Speed of the transition
  wheel: false, // Enable mouse wheel control
};
